import React from 'react'
import ImgFront from '../../images/front--25.webp'
import './postCardFront.scss'

const PostCardFront = () => {
  return <img className="PostCardFront" src={ImgFront} alt="The Gavula Family – 2025" />
}

export default PostCardFront
